import { Header } from "../../components/Header";

export const ParcelPage = () => {
	return (
		<>
			<Header />
		</>
	);
};
